export const useManyDisclosureProxy = (options, onChange) => {
    const onOpen = (key) => {
        if (onChange) {
            onChange(key);
        }
        options[key].onOpen();
    };
    const onClose = (key) => {
        if (onChange) {
            onChange(key);
        }
        options[key].onClose();
    };
    const closeAll = () => {
        const keys = Object.keys(options);
        keys.forEach((key) => {
            options[key].onClose();
        });
    };
    const isOpen = (key) => options[key].isOpen;
    return {
        onOpen,
        onClose,
        isOpen,
        buildOnOpen: (key) => () => onOpen(key),
        buildOnClose: (key) => () => onClose(key),
        closeAll,
    };
};
